import React, { createContext, useContext, useState } from "react";
import { notificationMessages } from "./notificationMessages";
import Notification from "./Notification";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const localStorageKey = 'notification';

    // Load setting from localStorage
    const [notificationsEnabled, setNotificationsEnabled] = useState(() => {
        const stored = localStorage.getItem(localStorageKey);
        return stored ? JSON.parse(stored).notification : true;
    });

    const [activeNotification, setActiveNotification] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    // Toggle function similar to your dark mode example
    const toggleNotifications = () => {
        const newSetting = !notificationsEnabled;
        setNotificationsEnabled(newSetting);
        localStorage.setItem(localStorageKey, JSON.stringify({ notification: newSetting }));
    };

    const triggerNotification = (id) => {
        if (!notificationsEnabled) return;

        const notif = notificationMessages.find((n) => n.id === id);
        if (!notif) return;

        setActiveNotification(notif);
        setIsVisible(true);

        setTimeout(() => setIsVisible(false), 5000);
        setTimeout(() => setActiveNotification(null), 5500);
    };

    return (
        <NotificationContext.Provider value={{
            triggerNotification,
            notificationsEnabled,
            toggleNotifications,
        }}>
            {children}
            {activeNotification && notificationsEnabled && (
                <Notification
                    type={activeNotification.type}
                    message={activeNotification.message}
                    linkText={activeNotification.linkText}
                    linkHref={activeNotification.linkHref}
                    isVisible={isVisible}
                />
            )}
        </NotificationContext.Provider>
    );
};
